const ACTIONS = {
    VISUALIZAR: 'LISTAR',
    INCLUIR: 'ADICIONAR',
    EDITAR: 'EDITAR',
    DELETAR: 'EXCLUIR',
    CONSULTAR: 'CONSULTAR',
};

const permissionEnums = {
    EXEMPLO_VISUALIZAR: `EXEMPLO_${ACTIONS.VISUALIZAR}`,
    EXEMPLO_CONSULTAR: `EXEMPLO_${ACTIONS.CONSULTAR}`,
    EXEMPLO_EDITAR: `EXEMPLO_${ACTIONS.EDITAR}`,
    EXEMPLO_DELETAR: `EXEMPLO_${ACTIONS.DELETAR}`,
    EXEMPLO_INCLUIR: `EXEMPLO_${ACTIONS.INCLUIR}`,

    ANALISE_NEGOCIAL_VISUALIZAR: `AVALIACAO_NEGOCIAL_${ACTIONS.VISUALIZAR}`,
    ANALISE_NEGOCIAL_EDITAR: `AVALIACAO_NEGOCIAL_${ACTIONS.EDITAR}`,

    ANALISE_PROPOSTA_META_VISUALIZAR: `AVALIACAO_META_${ACTIONS.VISUALIZAR}`,
    ANALISE_PROPOSTA_META_EDITAR: `AVALIACAO_META_${ACTIONS.EDITAR}`,
    ANALISE_PROPOSTA_META_CONSULTAR: `AVALIACAO_META_${ACTIONS.CONSULTAR}`,
    ANALISE_PROPOSTA_META_DELETAR: `AVALIACAO_META_${ACTIONS.DELETAR}`,

    PROPOSTA_INDICADOR_VISUALIZAR: `PROPOSTA_${ACTIONS.VISUALIZAR}`,
    PROPOSTA_INDICADOR_CONSULTAR: `PROPOSTA_${ACTIONS.CONSULTAR}`,
    PROPOSTA_INDICADOR_EDITAR: `PROPOSTA_${ACTIONS.EDITAR}`,
    PROPOSTA_INDICADOR_DELETAR: `PROPOSTA_${ACTIONS.DELETAR}`,
    PROPOSTA_INDICADOR_INCLUIR: `PROPOSTA_${ACTIONS.INCLUIR}`,

    STATUS_PROPOSTA_VISUALIZAR: `PROPOSTA_STATUS_${ACTIONS.CONSULTAR}`,

    ANALISE_METODOLOGICA_VISUALIZAR: `AVALIACAO_METODOLOGICA_${ACTIONS.VISUALIZAR}`,
    ANALISE_METODOLOGICA_EDITAR: `AVALIACAO_METODOLOGICA_${ACTIONS.EDITAR}`,

    INDICADOR_VISUALIZAR: `INDICADOR_${ACTIONS.VISUALIZAR}`,
    INDICADOR_CONSULTAR: `INDICADOR_${ACTIONS.CONSULTAR}`,
    INDICADOR_EDITAR: `INDICADOR_${ACTIONS.EDITAR}`,
    INDICADOR_DELETAR: `INDICADOR_${ACTIONS.DELETAR}`,
    INDICADOR_INCLUIR: `INDICADOR_${ACTIONS.INCLUIR}`,

    INDICADOR_SOLICITACOES_VISUALIZAR: `SOLICITACAO_ATIVACAO_INDICADOR_${ACTIONS.VISUALIZAR}`,
    INDICADOR_SOLICITACOES_EDITAR: `SOLICITACAO_ATIVACAO_INDICADOR_${ACTIONS.EDITAR}`,

    HISTORICO_INDICADOR_VISUALIZAR: `HISTORICO_VERSAO_INDICADOR_${ACTIONS.VISUALIZAR}`,
    HISTORICO_INDICADOR_CONSULTAR: `HISTORICO_VERSAO_INDICADOR_${ACTIONS.CONSULTAR}`,
};

export { ACTIONS, permissionEnums };
